import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_GET_LISTING_BY_ID,
} from 'api/actionTypes';

export default async function getAdminInfo({ state, apiClient }, { listingId }) {
  typeCheck('listingId::PositiveNumber', listingId);
  const statePath = ['listings', 'adminInfoById', listingId];
  if (state.exists(statePath)) {
    return state.get(statePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_GET_LISTING_BY_ID,
    state: state,
    queryId: `${listingId}`,
    payload: {
      listingId,
    },
    onSuccess(adminInfo) {
      state.set(statePath, adminInfo);
    },
  });
}
